import { ILocalitiesInitialState } from '@types';
import { createSelector } from 'reselect';
import { RootState } from 'store';

const localitiesSelector = (state: RootState) => state.localities;

const localitiesListSelector = createSelector([localitiesSelector], (localities: ILocalitiesInitialState) => localities.localitiesList);

const localitySelector = createSelector([localitiesSelector], (localities: ILocalitiesInitialState) => localities.locality);

export const localitiesSel = {
    localitiesSelector,
    localitySelector,
    localitiesListSelector,
};
